import { Pipe, PipeTransform } from '@angular/core';
import { AiChatReplyLayout, placeProductCards } from '../utils/ai-chat-product-cards';
import { renderMarkdown } from '../utils/markdown';

/**
 * Renders an assistant reply and cuts it into plain text and product entries, so each product's
 * picture can sit beside the entry that names it. Pure, so it re-runs only when the message
 * string or the cards change - once per `answer` frame while streaming.
 */
@Pipe({
  name: 'aiReplyEntries',
  standalone: true
})
export class AiReplyEntriesPipe implements PipeTransform {

  transform(
    value: string | null | undefined,
    skuCount = 0,
    links: (string | null)[] = [],
    recommended: boolean[] = []
  ): AiChatReplyLayout {
    return placeProductCards(renderMarkdown(value), skuCount, links, recommended);
  }
}
